<app-dialog-header [title]="'Transferir ingresso'" [disabled]="isLoading"></app-dialog-header>

<mat-dialog-content>
  <div class="">
    <div class="card-body">
      <form [formGroup]="assignForm" style="margin-top: 1em; display: grid; gap: 1em">
        <div class="alert alert-info">
          <p class="h4">Transferência de ingresso fácil e rápida!</p>
          <ol>
            <li>Informe o email e telefone da pessoa para quem você deseja transferir o ingresso.</li>
            <li>Clique em "Transferir".</li>
            <li>
              Pronto! Enviamos um email para o endereço informado com os passos para completar o cadastro (caso ainda
              não seja cadastrado) e acessar o ingresso na área "Meus Ingressos".
            </li>
          </ol>
        </div>
        <div class="form-group">
          <label for="user_email">Email:</label>
          <input
            type="email"
            id="user_email"
            name="user_email"
            class="form-control"
            formControlName="user_email"
            [ngClass]="{
              'is-invalid': assignForm.get('user_email')?.invalid,
            }" />
          @if (assignForm.get('user_email')?.invalid) {
            <div class="invalid-feedback">
              @if (assignForm.get('user_email')?.errors?.['required']) {
                <span>
                  {{ "Campo email é obrigatório" }}
                </span>
              }
              @if (assignForm.get('user_email')?.errors?.['email']) {
                <span> Formato de e-mail inválido. </span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <label for="user_email">Confirme o Email:</label>
          <input
            type="email"
            id="user_email_confirm"
            name="user_email_confirm"
            class="form-control"
            formControlName="user_email_confirm"
            [ngClass]="{
              'is-invalid': assignForm.get('user_email_confirm')?.invalid,
            }" />
          @if (assignForm.get('user_email_confirm')?.invalid) {
            <div class="invalid-feedback">
              @if (assignForm.get('user_email_confirm')?.errors?.['required']) {
                <span>
                  Campo confirmação de email é obrigatório
                </span>
              }
              @if (assignForm.get('user_email_confirm')?.errors?.['email']) {
                <span> Formato de e-mail inválido. </span>
              }
              @if (assignForm.get('user_email_confirm')?.errors?.['fieldsMismatch']) {
                <span>
                  Os campos de e-mail fornecidos não estão iguais.
                </span>
              }
            </div>
          }
        </div>

        <div class="mt-2">
          <label class="form-label" for="user_phone_number">Telefone: </label>
          <div class="form-group form-phone">
            <app-ddi-select formControlName="ddi"></app-ddi-select>
            <input
              placeholder="Telefone do convidado"
              type="phone"
              class="form-control"
              id="user_phone_number"
              formControlName="user_phone_number"
              placeholder="(00) 00000-0000"
              [mask]="assignForm.get('ddi')?.value === '+55' ? '(00) 00000-0000' : ''" />
          </div>
          @if (assignForm.get('user_phone_number')?.invalid && assignForm.get('user_phone_number')?.touched) {
            <div
              class="invalid-feedback">
              @if (assignForm.get("user_phone_number")?.errors?.["required"]) {
                <span> Campo Telefone não pode estar vazio </span>
              }
              @if (assignForm.get('user_phone_number')?.errors?.['invalidPhoneNumber']) {
                <span>
                  O campo telefone deve conter somente numeros
                </span>
              }
            </div>
          }
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button type="button" styleType="secondary" (btnClick)="dialogRef.close()" [disabled]="isLoading"
    >Cancelar</app-button
    >
    <app-button (btnClick)="onSubmitAssign()" [disabled]="isLoading"> Transferir </app-button>
  </mat-dialog-actions>
